export default __webpack_public_path__ + "static/media/coca-cola.8e584f05.jpg";